import withReducer from '../../store/withReducer'
import ResetPassword from './container'
import reducer from './module'

export default withReducer('resetPassword', reducer)(ResetPassword)



// WEBPACK FOOTER //
// ./src/legacy/pages/ResetPassword/index.js